const buttonSaveText = 'Сохранить';
const buttonSaveProgressText = 'Сохраняем...';

/** @KLUDGE объединить с "work-save-button-toggle.js" после теста */
function setSaveButtonActive(button) {
  button.disabled = false;
  button.classList.remove('opacity-50');
  const buttonText = button.querySelector('span');
  buttonText.textContent = buttonSaveText;
}

function setSaveButtonDisabled(button) {
  button.disabled = true;
  button.classList.add('opacity-50');
  const buttonText = button.querySelector('span');
  buttonText.textContent = buttonSaveProgressText;
}

export { setSaveButtonActive, setSaveButtonDisabled }